if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.isDefaultVariant = this.dataset.hasDefaultVariant || null;
        this.qvSwiper = null;
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");
        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]',
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            this.ensureVariantSync();
            super.show(opener);
            document.querySelector("bundle-element")?.updateEvent();
            this.dispatchEvent(
              new CustomEvent("quick-add:loaded", { bubbles: true }),
            );
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        if (this.qvSwiper) {
          this.qvSwiper.destroy(true, true); // Destroy old Swiper instance
        }
        if (this.isDefaultVariant && this.isDefaultVariant == "true") {
          this.initializeSwiper();
        }
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        // element.querySelectorAll('script').forEach(oldScriptTag => {
        //   const newScriptTag = document.createElement('script');
        //   Array.from(oldScriptTag.attributes).forEach(attribute => {
        //     newScriptTag.setAttribute(attribute.name, attribute.value)
        //   });
        //   newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        //   oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        // });
      }

      initializeSwiper() {
        this.qvSwiper = new Swiper(".qv-pdp-carousel", {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          navigation: {
            nextEl: ".qv-swiper-button-next",
            prevEl: ".qv-swiper-button-prev",
          },
        });
      }

      ensureVariantSync() {
        const variantSelector = this.modalContent.querySelector(
          "variant-radios, variant-selects",
        );
        const form = this.modalContent.querySelector(
          'form[data-type="add-to-cart-form"]',
        );
        if (!variantSelector || !form) return;

        variantSelector.addEventListener("change", () => {
          setTimeout(() => {
            const currentVariant = variantSelector.currentVariant;
            if (!currentVariant) return;

            const idInput = form.querySelector('input[name="id"]');
            if (idInput) idInput.value = currentVariant.id;

            const btn = form.querySelector('[name="add"]');
            if (btn && currentVariant.available) {
              btn.removeAttribute("disabled");
            }
          }, 200);
        });
      }

      preventVariantURLSwitching() {
        var selector = this.modalContent.querySelector(
          "variant-radios,variant-selects",
        );
        if (typeof selector != "undefined" && selector != null) {
          this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
        }
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability",
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`,
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]',
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }
    },
  );
}
